import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../Button/Button';
import TextField from '../TextField/TextField';
import TextareaField from '../TextareaField/TextareaField';
import { sendFeedback, clearMessages } from '../../store/feedback/actions';
import { validateEmail, emptyField } from "../../services/utils";
import i18n from "i18next";
import { H4 } from "../../styles/typography/typography"
import {
    InputWrapStyled,
    RowStyled,
    ErrorStyled,
    ErrorBlockStyled,
} from "../../components/LogIn/style";

import {
    FormSt,
    PopupLoginSt,
    ContentSt,
    TabContainerSt,
    ButtonWrapSt,
    InfoFormSt,
    TitleResetSt,

} from "./style";


const initialState = {
    isShowFeedbackBlock: true,
    isShowSuccessBlock: false,
    fullName: "",
    email: "",
    topic: "",
    text: "",
    formErrors: { fullName: "", email: "", topic: "", text: "" },
    loading: false
};

// валидация поля, возвращает новое состояние
const applyFieldValidation = (state, fieldName, value) => {
    const fieldValidationErrors = { ...state.formErrors };
    let emailValid = state.emailValid;

    switch (fieldName) {
        case 'email':
            emailValid = validateEmail(value)
            fieldValidationErrors.email = (value === "") ? i18n.t(`login.fill_in_the_field`) : emailValid ? "" : i18n.t(`login.invalid_email_format`);
            break;
        case 'fullName':
            fieldValidationErrors.fullName = emptyField(value)
            break;
        case 'topic':
            fieldValidationErrors.topic = emptyField(value)
            break;
        case 'text':
            fieldValidationErrors.text = emptyField(value)
            break;
        default:
            break;
    }

    return {
        ...state,
        formErrors: fieldValidationErrors,
        emailValid,
    };
};

const Feedback = () => {
    const [state, setState] = useState(initialState);

    const dispatch = useDispatch();
    const message = useSelector((store) => store.feedback.message);
    const successRequest = useSelector((store) => store.feedback.successRequest);

    const updateState = useCallback((patch) => {
        setState((prev) => ({ ...prev, ...patch }));
    }, []);

    // componentDidMount
    useEffect(() => {
        dispatch(clearMessages());
    }, [dispatch]);

    // componentDidUpdate: реакция на успешную отправку
    useEffect(() => {
        if (successRequest) {
            updateState({ isShowFeedbackBlock: false, isShowSuccessBlock: true });
        }
    }, [successRequest, updateState]);

    const handleFieldChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        setState((prev) => applyFieldValidation({ ...prev, [name]: value }, name, value));
    };

    // валидация всех полей формы перед отправкой
    const validateFormFeedback = () => {
        const isValidateEmail = validateEmail(state.email);
        const textError = i18n.t(`login.fill_in_the_field`); //Заполните поле

        const fullName = (!state.fullName) ? textError : ""

        let email = (!state.email) ? textError : ""

        if (state.email && !isValidateEmail) {
            email = i18n.t(`login.invalid_email_format`) //Неверный формат e-mail
        }
        const topic = (!state.topic) ? textError : ""
        const text = (!state.text) ? textError : ""

        if (fullName || email || topic || text) {
            updateState({ formErrors: { fullName, email, topic, text } });
            return false
        }
        return true
    };

    // кнопка отправить форму
    const handleFeedbackSubmit = (e) => {
        e.preventDefault();
        const isValid = validateFormFeedback();

        if (isValid) {
            updateState({ formErrors: { fullName: "", email: "", topic: "", text: "" } });
            // отправка на сервер
            dispatch(sendFeedback(state.fullName, state.email, state.topic, state.text));
        }
        else {
            updateState({ loading: false });
        }
    };

    const classForInputFullName = state.fullName ? "valid" : state.formErrors.fullName ? "invalid" : "";
    const classForInputEmail = state.emailValid ? "valid" : state.formErrors.email ? "invalid" : "";
    const classForInputTopic = state.topic ? "valid" : state.formErrors.topic ? "invalid" : "";
    const classForInputText = state.text ? "valid" : state.formErrors.text ? "invalid" : "";

    // блок с информацией об успешной отправки формы
    const contentSuccess =
        <FormSt>
            <InfoFormSt>{i18n.t(`feedback.success`)}</InfoFormSt>
        </FormSt>

    // все инпуты для формы
    const allInputs =
        [
            {
                class: classForInputFullName,
                type: 'text',
                name: 'fullName',
                placeholder: i18n.t(`feedback.name`),
                minLength: "4",
                maxLength: "50",
                error: state.formErrors.fullName
            },
            {
                class: classForInputEmail,
                type: 'email',
                name: 'email',
                placeholder: i18n.t(`feedback.email`),
                minLength: "4",
                maxLength: "50",
                error: state.formErrors.email,
                primary: true
            },
            {
                class: classForInputTopic,
                type: 'text',
                name: 'topic',
                placeholder: i18n.t(`feedback.topic`),
                maxLength: "50",
                error: state.formErrors.topic,
                primary: true
            },
        ];

    const allInputsInsert = allInputs.map((item, i) => {
        return (
            <RowStyled key={i}>
                <TextField
                    className={item.class}
                    type={item.type}
                    name={item.name}
                    placeholder={item.placeholder}
                    minLength={item.minLength}
                    maxLength={item.maxLength}
                    error={item.error}
                    value={item.value}
                    handleFieldChange={(e) => handleFieldChange(e)}
                />
            </RowStyled>
        )
    })

    return (
        <>
            <PopupLoginSt>
                <TabContainerSt>
                    <ContentSt>
                        {!state.isShowSuccessBlock
                            ?
                            <FormSt
                                onSubmit={(e) => handleFeedbackSubmit(e)}
                                action="#" method="post"
                            >
                                <TitleResetSt>
                                    <H4>{i18n.t(`feedback.title`)}</H4>
                                </TitleResetSt>
                                {allInputsInsert}
                                <RowStyled>
                                    <InputWrapStyled>
                                        <TextareaField
                                            handleFieldChange={(e) => handleFieldChange(e)}
                                            type="text"
                                            name="text"
                                            maxLength="5000"
                                            placeholder={i18n.t(`feedback.message`)}
                                            error={state.formErrors.text}
                                            className={classForInputText}
                                            primary
                                        />
                                    </InputWrapStyled>
                                </RowStyled>
                                <ButtonWrapSt>
                                    <Button as="a" href="/" label={i18n.t(`feedback.feedback_button`)} size="big" type="submit" width="100%" />
                                </ButtonWrapSt>
                                {/* Здесь сообщение об ошибке */}
                                <ErrorBlockStyled style={{ width: '100%' }}>
                                    <ErrorStyled style={{ textAlign: 'center' }}> {message}</ErrorStyled>
                                </ErrorBlockStyled>
                            </FormSt>
                            : contentSuccess
                        }
                    </ContentSt>
                </TabContainerSt>
            </PopupLoginSt>
        </>
    )
};

export default Feedback;
